import AssetSettings from './asset-settings'

export default AssetSettings
